import { useContext, useEffect } from "react"
import { Button, Modal } from "../../../../../components"
import { FormSection } from "./FormSection"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import type { FormBank } from "../types"
import { useApi } from "../../../../../utils"
import { Render, useCode } from "../utils"

export function CreateModal(props: {
  bank_code?: string
  bank_name?: string
  description?: string 
  toggle: () => void
  refetch?: () => void
}) {

  const api = useApi()
  const { toggle } = useContext(Render)
  const { dataCode} = useCode()

    useEffect(() => {
      if (dataCode?.code) {
        methods.setValue("bank_code", dataCode?.code)
      }
   // eslint-disable-next-line
    }, [dataCode?.code])

  type CreateListBank = Omit<FormBank, "bank_id"> 

  const defaultValues:CreateListBank= {
    bank_code: "",
    bank_name: "",
    description: ""
  }
  const validationSchema = yup.object().shape({
    bank_code: yup.string().label("Bank code").required().test('len', 'Must be exactly 3 characters', val => val.toString().length === 3),
    bank_name: yup.string().label("Bank name").required(),
    description: yup.string().label("Category name name").optional(),
  })
  const onSubmit = (value: CreateListBank) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/bank/add", value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 400) {
              return err.response.data.message || "Bad Request";
            } else {
              return "An error occurred";
            }
          }
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
        toggle()
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm<CreateListBank>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })

  return (
    <Modal isOpen title="CREATE BANK" size="xl" closeModal={props.toggle}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormSection />

          <Modal.Footer className="text-end">
            <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}